module.exports = __webpack_public_path__ + "img/carbon.9dfc27b.webp";